import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class ContactPaymentInformationPerCompany extends ModelBase {
  constructor(data?: any) {
    super();

    Object.defineProperties(this, {
      _directDebitCancelConfirmDate: { writable: true, enumerable: false },
      _directDebitConfirmDate: { writable: true, enumerable: false },
      _directDebitFromDate: { writable: true, enumerable: false },
      _requestFromInternetBankDate: { writable: true, enumerable: false },
      _responseToInternetBankSentDate: { writable: true, enumerable: false },
    });

    if (data) {
      this.companyNumberAndName = data.companyNumberAndName;
      this.directDebitStatus = data.directDebitStatus;
      this.payerNumber = data.payerNumber;
      this.directDebitCancelConfirmDate = data.directDebitCancelConfirmDate;
      this.directDebitConfirmDate = data.directDebitConfirmDate;
      this.directDebitFromDate = data.directDebitFromDate;
      this.requestFromInternetBankDate = data.requestFromInternetBankDate;
      this._responseToInternetBankSentDate = data.responseToInternetBankSentDate;
      this.bankGiroNumberFormatted = data.bankGiroNumberFormatted;
    }
  }

  companyNumberAndName: string;
  directDebitStatus: string;
  payerNumber: string;
  bankGiroNumberFormatted: string;

  private _directDebitCancelConfirmDate: LocalDate;
  get directDebitCancelConfirmDate(): LocalDate {
    return this._directDebitCancelConfirmDate;
  }
  set directDebitCancelConfirmDate(value: LocalDate) {
    this._directDebitCancelConfirmDate = LocalDate.fromDate(value);
  }

  private _directDebitConfirmDate: LocalDate;
  get directDebitConfirmDate(): LocalDate {
    return this._directDebitConfirmDate;
  }
  set directDebitConfirmDate(value: LocalDate) {
    this._directDebitConfirmDate = LocalDate.fromDate(value);
  }

  private _directDebitFromDate: LocalDate;
  get directDebitFromDate(): LocalDate {
    return this._directDebitFromDate;
  }
  set directDebitFromDate(value: LocalDate) {
    this._directDebitFromDate = LocalDate.fromDate(value);
  }

  private _requestFromInternetBankDate: LocalDate;
  get requestFromInternetBankDate(): LocalDate {
    return this._requestFromInternetBankDate;
  }
  set requestFromInternetBankDate(value: LocalDate) {
    this._requestFromInternetBankDate = LocalDate.fromDate(value);
  }

  private _responseToInternetBankSentDate: LocalDate;
  get responseToInternetBankSentDate(): LocalDate {
    return this._responseToInternetBankSentDate;
  }
  set responseToInternetBankSentDate(value: LocalDate) {
    this._responseToInternetBankSentDate = LocalDate.fromDate(value);
  }
}
